import { CardBody, TabContent, TabPane } from "reactstrap";
import { DATA } from "../../../../Data/UiKit/Tabs";
import { H6, Image, P } from "../../../../AbstractElements";
import { TabContentProp } from "../../../../Type/UiKits";

export const JustifytabContent = ({ basicTab }: TabContentProp) => {
  return (
    <CardBody className="px-0 pb-0">
      <TabContent activeTab={basicTab}>
        {DATA.map(({ id, items }, index) => (
          <TabPane tabId={id} key={index}>
            <div className="designer-details">
              {items.map(({ src, title, number }, index) => (
                <div className="designer-profile" key={index}>
                  <div className="designer-wrap">
                    <Image className="designer-img" src={src} alt="profile" />
                    <div className="designer-content">
                      <H6>{title}</H6>
                      <P> {number}</P>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </TabPane>
        ))}
      </TabContent>
    </CardBody>
  );
};
